import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoRecievedImagesIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 85,
	height: 79,
	viewBox: "0 0 85 79",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 45.2086,
			cy: 39.7019,
			rx: 39.0055,
			ry: 38.4402,
			fill: "#F4F4F4"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 40.0055,
			cy: 39.7019,
			rx: 39.0055,
			ry: 38.4402,
			stroke: "#A0A0A0",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2687 54.3264L17.9163 54.6811L18.2687 54.3264C16.8229 52.8899 15.9083 50.9135 15.7117 48.7742C15.5151 46.6348 16.0515 44.4958 17.2109 42.7693C18.3698 41.0438 20.0651 39.8569 21.9636 39.4226L22.4204 39.3181L22.3457 38.8555C21.8221 35.6133 22.3895 32.2761 23.939 29.4587L23.9404 29.4562C25.0644 27.3849 26.6716 25.6835 28.5919 24.5226C30.5117 23.362 32.6769 22.7825 34.865 22.8398C37.0531 22.8971 39.191 23.5895 41.0584 24.8499C42.9263 26.1106 44.4573 27.8951 45.4892 30.0237L45.7537 30.5692L46.2389 30.2057C47.3977 29.3377 48.7939 28.9491 50.1814 29.0996C51.5694 29.2501 52.8725 29.9322 53.8564 31.0374L53.8566 31.0377C54.8117 32.1091 55.4138 33.5058 55.5583 35.0052L55.5987 35.4249L56.0192 35.4559C57.8398 35.5902 59.5924 36.2866 61.0718 37.4699C62.5516 38.6536 63.6974 40.2763 64.3697 42.1524C65.0421 44.0287 65.2115 46.0767 64.857 48.0558C64.5025 50.0349 63.6398 51.8584 62.3746 53.3148L62.3737 53.3158C61.507 54.3189 60.4681 55.1212 59.3192 55.6782C58.1722 56.2344 56.9372 56.5357 55.6856 56.5661L23.5209 56.5718C21.5842 56.5564 19.713 55.7614 18.2687 54.3264Z",
			stroke: "#B6B6B6"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_17802_72898)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M38.6337 50.8989C38.9072 51.1687 39.2779 51.3203 39.6644 51.3203C40.0509 51.3203 40.4216 51.1687 40.6951 50.8989L46.1977 45.4651C46.4713 45.1947 46.625 44.8281 46.625 44.4457C46.625 44.0634 46.4713 43.6968 46.1977 43.4264C45.9241 43.1561 45.5529 43.0042 45.166 43.0042C44.779 43.0042 44.4079 43.1561 44.1343 43.4264L41.1229 46.4008V35.319C41.1229 34.9368 40.9693 34.5702 40.6957 34.3C40.4222 34.0297 40.0512 33.8779 39.6644 33.8779C39.2776 33.8779 38.9066 34.0297 38.6331 34.3C38.3595 34.5702 38.2059 34.9368 38.2059 35.319V46.4008L35.1954 43.4264C35.06 43.2926 34.8991 43.1864 34.7221 43.1139C34.5451 43.0415 34.3554 43.0042 34.1638 43.0042C33.9722 43.0042 33.7824 43.0415 33.6054 43.1139C33.4284 43.1864 33.2676 43.2926 33.1321 43.4264C32.9966 43.5603 32.8891 43.7192 32.8158 43.8941C32.7425 44.069 32.7048 44.2564 32.7048 44.4457C32.7048 44.6351 32.7425 44.8225 32.8158 44.9974C32.8891 45.1723 32.9966 45.3312 33.1321 45.4651L38.6337 50.8989Z",
				fill: "#A0A0A0"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_17802_72898",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 23.3366,
				height: 23.0572,
				fill: "white",
				transform: "translate(28 31)"
			})
		}) })
	]
});
export default SvgNoRecievedImagesIcon;
